import { Link } from "react-router-dom";
import { B, bFonts } from "../tokens";
import { useBrand } from "../brand";

interface BBrandProps {
  to?: string;
  size?: "sm" | "md";
  /** "dark" renders light text for use on the navy sidebar. */
  tone?: "light" | "dark";
}

/** The square brand mark: the app's logo image, else ledger rules with a settled check. */
export function BrandMark({ size = 28 }: { size?: number }) {
  const { tint, logo } = useBrand();
  if (logo) {
    return (
      <img src={logo} width={size} height={size} alt="" aria-hidden="true"
        style={{ flex: "0 0 auto", display: "block", borderRadius: Math.round(size * 0.22) }} />
    );
  }
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" style={{ flex: "0 0 auto" }}>
      <rect width="32" height="32" rx="8" fill={tint.ink} />
      <path d="M8 11h16M8 16h9M8 21h6" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" opacity="0.9" />
      <path d="M18.5 21.2l2.6 2.6 4.6-5.6" fill="none" stroke="#7ee0cd" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// Logo lockup: mark + "Set & Ledger" wordmark.
export default function BBrand({ to = "/", size = "md", tone = "light" }: BBrandProps) {
  const { name } = useBrand();
  const [left, right] = name.includes("&") ? name.split("&").map((s) => s.trim()) : [name, ""];
  const fontSize = size === "sm" ? 15 : 18;
  return (
    <Link
      to={to}
      aria-label={name}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 10,
        textDecoration: "none",
        color: tone === "dark" ? "#fff" : B.ink,
      }}
    >
      <BrandMark size={size === "sm" ? 26 : 30} />
      <span style={{ fontFamily: bFonts.display, fontSize, fontWeight: 650, letterSpacing: "-0.02em", whiteSpace: "nowrap" }}>
        {left}
        {right && (
          <>
            {" "}
            <span style={{ color: tone === "dark" ? "#7ee0cd" : B.accent, fontWeight: 500 }}>&amp;</span> {right}
          </>
        )}
      </span>
    </Link>
  );
}
